module.exports = angular.module('cartographer.common.storage', [])

$ = require 'jquery'

module.exports.run $DI (crtConfig) ->
  $.cookie.defaults = crtConfig.storage.cookie.defaults
  return

module.exports.factory 'crtStorage', $DI (crtLog, crtConfig, crtSerialize) ->
  prefix = crtConfig.storage.prefix

  get = (key, orElse = undefined) ->
    json = $.cookie("#{prefix}#{key}")
    try
      value = if json then crtSerialize.decode(JSON.parse(json)) else orElse
      # crtLog.info("crtStorage.get('#{key}') >> #{json}", value)
    catch exn
      # crtLog.warn("crtStorage.get('#{key}') >> undefined", orElse)
      value = orElse
    value

  remove = (key) ->
    # crtLog.info("crtStorage.remove('#{key}')")
    $.removeCookie("#{prefix}#{key}")
    return

  set = (key, value) ->
    # crtLog.info("crtStorage.set('#{key}', '#{JSON.stringify(value)}')", value)
    if value == undefined
      remove(key)
    else
      $.cookie("#{prefix}#{key}", JSON.stringify(crtSerialize.encode(value)))
    return

  return {
    get
    set
    remove
  }
